import {ValidationType} from './ValidationType'

export const ContactTasksValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Type: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Status: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  ContactID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  WorkOrderID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  PropertyOfferID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  CertificateID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  ContactTaskID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Subject: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: false,
    maxLength: 255,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  AddedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  StartDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  DueDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  UpdatedDate: {
    validationType: ValidationType.DateTime,
    isRequired: true,
    maxLength: 0,
    maxValue: 0
  },
  CompletedDate: {
    validationType: ValidationType.DateTime,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  UserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AssignedUserID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AppointmentID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  Priority: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  SiteID: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 10,
    maxValue: 2147483647
  },
  TaskTypeID: {
    validationType: ValidationType.Numeric,
    isRequired: true,
    maxLength: 10,
    maxValue: 2147483647
  },
  AssignedUserAcknowledged: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  AlwaysShowAtTop: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DesktopAlert: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  DesktopAlertShowOnProperties: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  }
};
